import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Innlogget sjåførs kjøretøy (sanntid). Tom liste mens de lastes eller hvis sjåføren ikke har noen.
export function useDriverVehicles() {
  const { currentUser } = useAuth();
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    if (!currentUser) return undefined;
    const q = query(collection(db, 'vehicles'), where('driverUid', '==', currentUser.uid));
    return onSnapshot(
      q,
      snap => setVehicles(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
      err => console.error('useDriverVehicles:', err),
    );
  }, [currentUser]);

  return vehicles;
}
